/** fanza 쪽지(메시지) 메뉴 활성화에 필요한 최소 coin(ハート) 사용량 */
export const FANZA_MESSAGE_ENABLE_MIN_COIN_USE = 100;

/** 쪽지 메뉴 비활성 상태에서 안내하는 문구 (toast/confirm 공통) */
export const FANZA_MESSAGE_DISABLED_TEXT = 'ハート100個以上の使用でメッセージメニューが有効化されます。';
